import { CommonModule } from '@angular/common';
import { Component, computed, Inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Store } from '@ngxs/store';
import { getYear } from 'date-fns';
import { ProfitLossStatement } from 'ng2-app/models/dscr/ProfitLossStatementItem.struct';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';
import { CreateProfitLossStatementItem } from 'ng2-app/store/profit-loss-statements/dscr.actions';

interface ProfitLossStatementDialogData extends ProfitLossStatement {
  editing: boolean;
}

@Component({
  selector: 'app-profit-loss-statement-dialog',
  standalone: true,
  templateUrl: './profit-loss-statement.dialog.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
  ],
})
export class ProfitLossStatementDialogComponent {

  borrowerId = toSignal( this.store.select( BorrowerState.borrowerId ) );

  formGroup: FormGroup;

  editMode = computed(() => !!this.data?.editing);
  titleVariant = computed(() => {
    return this.editMode() ? 'Edit' : 'Create';
  });

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<ProfitLossStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: ProfitLossStatementDialogData,
  ) {
    this.formGroup = new FormGroup({
      year: new FormControl<number>(getYear(new Date()), [Validators.required]),
      months: new FormControl<number>(this.data?.months || 0, [Validators.required]),
      revenue: new FormControl<number>(this.data?.revenue || 0, [Validators.required]),
      costOfGoodsSold: new FormControl<number>(this.data?.costOfGoodsSold || 0, [Validators.required]),
      netIncome: new FormControl<number>(this.data?.netIncome || 0, [Validators.required]),
      compensationOfOfficers: new FormControl<number>(this.data?.compensationOfOfficers || 0, [Validators.required]),
      businessInterest: new FormControl<number>(this.data?.businessInterest || 0, [Validators.required]),
      depreciation: new FormControl<number>(this.data?.depreciation || 0, [Validators.required]),
      amortization: new FormControl<number>(this.data?.amortization || 0, [Validators.required]),
    });
  }

  save() {
    const borrowerId = this.borrowerId();
    const data = {
      ...this.formGroup.value,
      borrowerId,
    } as ProfitLossStatement;
    this.store.dispatch( new CreateProfitLossStatementItem(
      this.borrowerId() as number,
      data,
    ));

    this.dialogRef.close();
  }
}
